// start:ng42.barrel
export * from './tutorials.model';
// end:ng42.barrel

